import { Component, forwardRef, Input } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { RegionFeatureStatus } from '../../shared/region-feature-status.model';

@Component({
  selector: 'app-region-feature-status',
  templateUrl: './region-feature-status.component.html',
  styleUrls: ['./region-feature-status.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: forwardRef(() => NgForm) }],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RegionFeatureStatusComponent),
      multi: true
    }
  ]
})
export class RegionFeatureStatusComponent implements ControlValueAccessor {

  @Input()
  public i18nKeyNode: string;

  @Input()
  public name: string;

  public available: boolean;

  public forced: boolean;

  _regionFeature: RegionFeatureStatus;

  get regionFeature() {
    return this._regionFeature;
  }

  set regionFeature(value) {
    this._regionFeature = value;
    switch (value) {
      case RegionFeatureStatus.FORCED :
        this.available = true;
        this.forced = true;
        break;
      case RegionFeatureStatus.NOT_AVAILABLE :
        this.available = false;
        this.forced = false;
        break;
      case RegionFeatureStatus.AVAILABLE :
        this.available = true;
        this.forced = false;
        break;
      case null:
        this.available = false;
        this.forced = false;
        break;
      default :
        console.error('region feature status not handled');
    }
  }

  constructor() {}

  onChange: (value: RegionFeatureStatus) => void = () => {
  };

  onTouch: () => void = () => {
  };

  writeValue(value: any) {
    this.regionFeature = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  updateFeature() {
    if (this.available) {
      if (this.forced) {
        this.regionFeature = RegionFeatureStatus.FORCED;
      } else {
        this.regionFeature = RegionFeatureStatus.AVAILABLE;
      }
    } else {
      this.regionFeature = RegionFeatureStatus.NOT_AVAILABLE
      this.forced = false;
    }
    this.onChange(this.regionFeature);
  }
}
